import { render, staticRenderFns } from "./PropertyTable.vue?vue&type=template&id=3d029128&scoped=true&"
import script from "./PropertyTable.vue?vue&type=script&lang=js&"
export * from "./PropertyTable.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTable.vue?vue&type=style&index=0&id=3d029128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d029128",
  null
  
)

export default component.exports